import { render } from "./FootbalTournaments.vue?vue&type=template&id=2b409d51&scoped=true"
import script from "./FootbalTournaments.vue?vue&type=script&lang=js"
export * from "./FootbalTournaments.vue?vue&type=script&lang=js"

import "./FootbalTournaments.vue?vue&type=style&index=0&id=2b409d51&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b409d51"]])

export default __exports__